import React from 'react';
import {Button} from "reactstrap";
import HTML from '../../common/HtmlHelpers';
import {UsersEndpoints} from "../../common/ProxyEndpoints";
import TTLProxy from "../../common/TTLAsyncProxy";
import MDProgress from 'react-md-progress-bar';
import SmartDialog from "../SmartDialog/SmartDialog";
import {Form, Formik} from "formik";
import FormInput from "../FormInput";
import * as yup from 'yup';
import Utils from "../../common/Utils";

const Schema = yup.object().shape({
   originalPassword: yup.string().required().min(1).max(256).label("Current Password"),
   newPassword: yup.string().required().min(6).max(256).label("New Password"),
   confirmPassword: yup.string().required().min(6).max(256).label("Confirm Password")
       .oneOf([yup.ref("newPassword"),null],"Passwords do not match")
});


class ChangeAccountPassword extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            isBusy: false,
            errorMessage: null,
            faultedInput: null
        };

        this.proxy = TTLProxy.getInstance();
    }

    togglePasswordDialog(){

        this._dlg.toggle();
        this.setState({
            errorMessage: null,
            faultedInput : null
        });

    }

    show(){
       this._dlg.show();
    }

    async onChangePassword({ originalPassword ,  newPassword, confirmPassword }){

        const proxy = this.proxy;

        this.setState({
            isBusy: true,
            errorMessage: null
        });

        try {

            const response = await proxy.processRequest(UsersEndpoints.changePassword(originalPassword,newPassword,confirmPassword));

            if(response.ok){

                //
                this.setState({ isBusy: false });

                //
                HTML.toastMessage('Password changed successfully!');

                //  toggle dialog
                return this.togglePasswordDialog();

            }

        }
        catch (e) {

            //  toast error
            HTML.toastError(Utils.getResponseError(e));

        }
        finally {
            this.setState({ isBusy: false });
        }

    }

    render(){
        return (<SmartDialog title={"Change Password"} ref={r => this._dlg= r}>


            <Formik onSubmit={async (values,{ setSubmitting }) => {

                try {
                    await this.onChangePassword(values);
                }
                catch (e) {

                }
                finally {
                    setSubmitting(false);
                }

            }}
            validationSchema={Schema}
            initialValues={{
                originalPassword: '',
                newPassword: '',
                confirmPassword: ''
            }}>
                {({ isValid , isSubmitting , errors }) => {

                    return <Form>


                        <div className="p-3 mb-2" style={{
                            boxShadow: 'rgb(220, 220, 220) 0px 1px 1px 2px',
                            borderRadius: 5
                        }}>

                        <div className="p-3" style={{ backgroundColor: "#eeeeee" }}>

                            <FormInput name="originalPassword"
                                       type={"password"}
                                       icon="fa fa-lock"
                                       placeholder={"Enter your current password"}
                                       maxLength={256}
                                       title={"Current Password"}/>

                        </div>
                                   <hr/>


                                       <FormInput name="newPassword"
                                                  type={"password"}
                                                  icon="fa fa-lock"
                                                  placeholder={"Enter new password"}
                                                  maxLength={256}
                                                  title={"New Password"}/>

                                       <FormInput name="confirmPassword"
                                                  type={"password"}
                                                  icon="fa fa-lock"
                                                  placeholder={"Confirm password"}
                                                  maxLength={256}
                                                  title={"Please confirm password"}/>



                                   </div>

                        {this.state.isBusy && <MDProgress show={true} overlay={true}/>}

                        <Button color="green" disabled={isSubmitting || !isValid} block type="submit"><i className={"fa fa-check"}/> Change Password</Button>


                    </Form>
                }}
            </Formik>


        </SmartDialog>);
    }

}

export default ChangeAccountPassword;


// WEBPACK FOOTER //
// ./src/components/ChangeAccountPassword/ChangeAccountPassword.js